import { MedewerkersOpStation } from "@/entities/medewerkers-op-station";
import { cn } from "@/shared/utils";
import { MedewerkersStationBemenstIndicator, MedewerkersStationStatus, MedewerkersStationStatusIcon } from "../shared";

type MedewerkersStationLezenProps = {
    station: MedewerkersOpStation;
    stationDisplayName: string;
};

export function MedewerkersStationLezen({ station, stationDisplayName }: MedewerkersStationLezenProps) {
    const disabled = !station.veilig || (station.aantalBeschikbareVossen === 0 && station.mollen.length === 0);

    return (
        <div className="flex p-4" data-testid={`vos-station-${station.stationCode}`}>
            <div className="flex flex-1 items-center gap-2">
                <MedewerkersStationStatusIcon station={station} className={cn(station.status === "NietAangevraagd" && "w-4")} />
                <span className={cn("text-content-default font-medium", disabled && "opacity-50")}>{stationDisplayName}</span>
                <MedewerkersStationBemenstIndicator station={station} disabled={disabled} />
            </div>
            <MedewerkersStationStatus station={station} toonBeschikbareVossen={false} />
        </div>
    );
}
